<app-header></app-header>

<div class="mis_view">
  <div class="container-fluid h-100">
    <div class="header_mis">
      <nav aria-label="breadcrumb" class="float-left d-flex w-100" style="padding-top: 15px;">
        <ol class="breadcrumb breadcrumb-right-panel" style="border-radius:0px ">
          <li class="breadcrumb-item"><a href="/gis">{{'submitdata.Home' | translate}}</a></li>
          <li class="breadcrumb-item active pointer" aria-current="page"><a (click)="redirectWhatsNew()">{{ 'broadcasting.whatsnew' | translate }}</a></li>
          <li class="breadcrumb-item active" aria-current="page" *ngIf="activeDisplay== 'archives'">{{ 'broadcasting.Archives' | translate }}</li>
          <li class="breadcrumb-item active" aria-current="page" *ngIf="activeDisplay== 'viewall'">{{ 'broadcasting.View All' | translate }}</li>
        </ol>
      </nav>

      <div class="card blue_shadow p-3">
        <div class="border-bottom pb-2 mb-2">
          <h1 *ngIf="activeDisplay== 'whatsnew'">{{ 'broadcasting.whatsnew' | translate }}</h1>
          <h1 *ngIf="activeDisplay== 'archives'">{{ 'broadcasting.Archives' | translate }}</h1>
          <h1 *ngIf="activeDisplay== 'viewall'">{{ 'broadcasting.View All' | translate }}</h1>
        </div>

        <div *ngIf="activeDisplay== 'whatsnew'" class="text-center">
          <table class="table text-center" style="width: 90%;">
            <thead>
              <tr>
                <th>{{ 'dataSubs.sno' | translate }}</th>
                <th style="width: 65%;">{{ 'broadcasting.Subject' | translate }}</th>
                <th>{{ 'broadcasting.Date of Upload' | translate }}</th>
                <th>{{ 'broadcasting.Document Download' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of broadcastData; let i=index">
                <td>{{i+1}}</td>
                <td>{{doc.description}}</td>
                <td>{{formatTmStmp(doc.insertTs)}}</td>
                <td><i class="fa fa-download pointer" (click)="downloadDoc(doc.fileUUID,formatTmStmp(doc.insertTs))"></i></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="activeDisplay== 'archives'">
          <div class="col-md-12 d-flex justify-content-start mt-4 px-3">
            <div class="form-group " >
              <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedYearMonth['ay']" class="form-control custom-selectbox w-auto">
                <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
              </select>
            </div>
            <div class="form-group " style="margin-left: 15px;">
              <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
              <select style="width: 125px;margin-right: 10px;" [(ngModel)]="selectedYearMonth['month']" class="form-control custom-selectbox">
                <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
                <option  *ngFor="let month of monthList"  [value]="month.key">
                  {{'monthmaps.' + month['value'] | translate}}</option>
              </select>
            </div>
            <div class="form-group" style="width: 40%;">
              <label>{{ 'broadcasting.Search by Subject' | translate }}<span class="required-field"></span>
              </label><br>
              <input type="text" style="width: 98%;height: 45%;" [(ngModel)]="docSubject">      
            </div>
            <div class="form-group" style="margin-top: 10px;">
              <label class="w-100">&nbsp;&nbsp;</label>
              <button class="btn btn-info pointer"(click)="getSearchDoc()" type="submit">{{ 'broadcasting.Search' | translate}}</button>
            </div>
          </div>

          <div *ngIf="archiveData" class="text-center">
            <table class="table text-center" style="width: 90%;">
              <thead>
                <tr>
                  <th>{{ 'dataSubs.sno' | translate }}</th>
                  <th style="width: 65%;">{{ 'broadcasting.Subject' | translate }}</th>
                  <th>{{ 'broadcasting.Date of Upload' | translate }}</th>
                  <th>{{ 'broadcasting.Document Download' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of archiveData; let i=index">
                  <td>{{i+1}}</td>
                  <td>{{doc.description}}</td>
                  <td>{{formatTmStmp(doc.insertTs)}}</td>
                  <td><i class="fa fa-download pointer" (click)="downloadDoc(doc.fileUUID,formatTmStmp(doc.insertTs))"></i></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="showNoData" class="text-center">
            <hr style="width: 80%;height:2px;background-color:gray">
            <h3>{{ 'broadcasting.No data found' | translate }}</h3>
          </div>
          
        </div>

        <div *ngIf="activeDisplay== 'viewall'" class="text-center">
          <table class="table text-center" style="width: 90%;">
            <thead>
              <tr>
                <th>{{ 'dataSubs.sno' | translate }}</th>
                <th style="width: 65%;">{{ 'broadcasting.Subject' | translate }}</th>
                <th>{{ 'broadcasting.Date of Upload' | translate }}</th>
                <th>{{ 'broadcasting.Document Download' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of dataObs | async; let i=index">
                <td>{{i+1}}</td>
                <td>{{doc.description}}</td>
                <td>{{formatTmStmp(doc.insertTs)}}</td>
                <td><i class="fa fa-download pointer" (click)="downloadDoc(doc.fileUUID,formatTmStmp(doc.insertTs))"></i></td>
              </tr>
            </tbody>
          </table>
          <mat-paginator [hidePageSize]="true" [showFirstLastButtons]="true" [pageSize]="50"></mat-paginator>
        </div>

        <div class="align-self-end pointer" *ngIf="activeDisplay== 'whatsnew'">
          <h4><a style="color: blue;" (click)="openArchives()">{{ 'broadcasting.Archives' | translate }}</a>&nbsp;|&nbsp;
            <a style="color: blue;" (click)="openViewall()">{{ 'broadcasting.View All' | translate }}</a>
          </h4>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>